// extracted by mini-css-extract-plugin
module.exports = {"element":"internal-cta-block_element__2Veqi","item":"internal-cta-block_item__3Gmx0"};